module.exports = "<div class=\"col-xs-4\">\r\n<h3 *ngIf=\"userStats\">\r\n    Statistiken für den Benutzer {{userStats[0].user.firstName}} {{userStats[0].user.lastName}} \r\n</h3>\r\n<app-table-template *ngIf=\"userStats && columns\" [data]=\"userStats\" [columns]=\"columns\"></app-table-template><br>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/userStat/user.stat.component.html
// module id = 279
// module chunks = 1